// frontend/src/components/common/Spinner.jsx
import "./ui.css";

export default function Spinner({ size = 16, label = "Loading", className = "" }) {
  return (
    <span
      className={`spinner ${className}`.trim()}
      style={{ width: size, height: size }}
      role="status"
      aria-label={label}
    />
  );
}
